import $ from "jquery";
import {GPProjectView} from "./gp-projectview";
import Mustache from "mustache";
import {selectedItemSet, mode, snippetsStore} from "./gp.js";
import {textFilter, sizeFilter, colorFilter, lightFilter, seasonFilter, typeFilter} from "./gp-plantpickerstore";
import {get} from "svelte/store";

export let GPTutorial = {

    steps: null,
    steps_en: [
        {
            placement: "none",
            element: "#GPTutorialCenter",
            title: "Welcome to the GardenPuzzle app! ",
            content: '<img src="img/gpLogoOnly.svg"/><div><p>This quick tutorial will guide you through the most important features of the app in few easy steps.</p><p>If you need this tutorial later, you will find in the <i class="fa fa-bars"></i> MENU in the right top corner of the screen at any time.</p><p>Click <b>"Start"</b> to run the tutorial or <b>"Close"</b> to use the app right away.</p></div>',
            template: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="modal" aria-labelledby="tutorial_popover_title" aria-modal="true">' +
            '<div class="arrow"></div>' +
            '<h3 id="tutorial_popover_title" class="popover-title"></h3>' +
            '<a class="gpTutorialClose" href="#" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></a>' +
            '<div class="popover-content"></div>' +
            '<div class="popover-footer">' +
            '<button type="button" class="btn btn-default gpTutorialCloseBtn"><i class="fa fa-times" aria-hidden="true"></i> Close</button>' +
            '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
            '<button type="button" class="btn btn-primary gpTutorialNext">Start <i class="fa fa-long-arrow-alt-right" aria-hidden="true"></i></button>' +
            '</div>' +
            '</div>',
            allowed : () => {return true;}
        },
        {
            placement: function(popover, element) {if ($('.visible-md-block').is(':visible') || $('.visible-lg-block').is(':visible')) return "right"; else return "top";},
            element: "#GPPlantPickerList",
            title: "Plant finder",
            content: "Here is our carefully selected choice of most popular garden plants.",
            action: function() {
                textFilter.set('');
                typeFilter.set('filterAll');
                sizeFilter.set('filterAll');
                lightFilter.set('filterAll');
                colorFilter.set('filterAll');
                seasonFilter.set('filterAll');
                mode.set("Plants")},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: "#GPPlantSearchBlock",
            title: "Filtering plants choice",
            content: "Use this filters to find plants of right type, size and light requirements. You can also search plants by name. Gray&nbsp;× will clear all filters.",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(2)",
            title: "Plant size",
            content: "Size of each plant's thumbnail will signal the actual size of a plant (and for really big ones we display a gardener silhouette for comparison).",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(0)",
            title: "Adding plant to project",
            content: "Click to select a plant. Then, to add it to your design, click somewhere on the garden image (preferably below the horizon line).",
            action: function() {$(".GPPlantPickerItem:eq(0)").click();},
            allowed : () => {return true;}
        },
        {
            placement: function (context, source) {if ($(source).offset().left > 300) return "left"; else return "auto";},
            element: "#GPProjectView",
            title: "Correcting plant position",
            content: "Added plants can be dragged around to get the best effect. Its size will adjust automatically, based on its type, placement and general scene scale. ",
            action: function() {if (!GP.project.items.length) {GP.project.addPlant(4066, 1160, 1160, 1); GPProjectView.initFromProject();}},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: "#itemInstanceDetails",
            title: "Extra operations",
            content: "Click a plant on the project to bring up a context menu, that allows you to remove plant or manually correct its size.",
            action: function() {mode.set("Plants"); selectedItemSet.set([GP.project.items[0]]);},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPModeTabs",
            title: "Structures",
            content: "Switch these tabs to enhance design with small architecture and garden furniture.",
            action: function() {mode.set("Structures");},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPTexturePickerItem:eq(0)",
            title: "Lawns and other surfaces",
            content: "To apply surfaces (e.g. grass, stones, paths), select one of the textures and 'paint' on the image (surfaces can be applied to ground only, so draw in the lower part of image).",
            action: function() {mode.set("Textures");},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPSnippetPickerItem:eq(0)",
            title: "Ready to use plant arrangements",
            content: "Use these pre-designed arrangements to quickly add some variety to your design. You can also create your own arrangements and save them for later use.",
            action: function() {mode.set("Snippets");},
            allowed: () => {return get(snippetsStore) && get(snippetsStore).length}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(0)",
            title: "Plant details",
            content: "Back to plants pane - clicking on the <i class='fa fa-question-circle'></i> icon will display plant details",
            action: function() {mode.set("Plants");},
            allowed : () => {return true;}
        },
        {
            placement: "bottom",
            element: ".GPSeasonSwitch",
            title: "Switching seasons",
            content: "This icon will switch the view between seasons of the year.<br/><br/>Plant added to the project will automatically switch its image to the appropriate for selected season. Sometimes that might cause flowers to disappear - don't worry, simply switch the view to summer or spring!",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPMainNav",
            title: "Menu",
            content: "<span class='hidden-xs'>Here are the shortcut buttons for common actions - selecting a scenery (background image), setting up soil and climate conditions to filter only most suitable plants, saving your project etc. </span>Icon <i class='fa fa-bars'></i> will open menu with additional actions.<br/><br/>Have fun!",
            template: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="modal" aria-labelledby="tutorial_popover_title" aria-modal="true">' +
                '<div class="arrow"></div>' +
                '<h3 id="tutorial_popover_title" class="popover-title"></h3>' +
                '<a class="gpTutorialClose" href="#" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></a>' +
                '<div class="popover-content"></div>' +
                '<div class="popover-footer">' +
                '<button type="button" class="btn btn-default gpTutorialPrev"><i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i> Previous</button>' +
                '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
                '<button type="button" class="btn btn-primary gpTutorialNext">Close <i class="fa fa-times" aria-hidden="true"></i></button>' +
                '</div>' +
                '</div>',
            allowed : () => {return true;}
        },
    ],

    steps_pl: [
        {
            placement: "none",
            element: "#GPTutorialCenter",
            title: "Witaj w aplikacji GardenPuzzle! ",
            content: '<img src="img/gpLogoOnly.svg"/><div><p>Ten krótki samouczek zilustruje najważniejsze funkcje aplikacji w&nbsp;kilku krótkich krokach.</p><p>Jeśli zechcesz uruchomić go później, znajdziesz go w <i class="fa fa-bars"></i> MENU w&nbsp;prawym górnym rogu ekranu.</p><p>Naciśnij <b>"Start"</b> aby uruchomić samuczek lub <b>"Zamknij"</b> aby zacząć od razu korzystać z aplikacji.</p></div>',
            template: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="modal" aria-labelledby="tutorial_popover_title" aria-modal="true">' +
            '<div class="arrow"></div>' +
            '<h3 id="tutorial_popover_title" class="popover-title"></h3>' +
            '<a class="gpTutorialClose" href="#" aria-label="Zamknij"><i class="fa fa-times" aria-hidden="true"></i></a>' +
            '<div class="popover-content"></div>' +
            '<div class="popover-footer">' +
            '<button type="button" class="btn btn-default gpTutorialCloseBtn"><i class="fa fa-times" aria-hidden="true"></i> Zamknij</button>' +
            '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
            '<button type="button" class="btn btn-primary gpTutorialNext">Start <i class="fa fa-long-arrow-alt-right" aria-hidden="true"></i></button>' +
            '</div>' +
            '</div>',
            allowed : () => {return true;}
        },
        {
            placement: function(popover, element) {if ($('.visible-md-block').is(':visible') || $('.visible-lg-block').is(':visible')) return "right"; else return "top";},
            element: "#GPPlantPickerList",
            title: "Wyszukiwarka roślin",
            content: "Tu znajdziesz naszą starannie wybraną kolekcję najpopularniejszych roślin ogrodowych.",
            action: function() {
                textFilter.set('');
                typeFilter.set('filterAll');
                sizeFilter.set('filterAll');
                lightFilter.set('filterAll');
                colorFilter.set('filterAll');
                seasonFilter.set('filterAll');
                mode.set("Plants")},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: "#GPPlantSearchBlock",
            title: "Filtrowanie listy roślin",
            content: "Użyj tych filtrów, by wyszukać rośliny według rodzaju, rozmiaru i wymagań nasłonecznienia. Możesz także wyszukiwać rośliny po nazwie. Szary&nbsp;×&nbsp;wyczyści wszystkie filtry.",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(2)",
            title: "Rozmiar roślin",
            content: "Wielkość ikonki każdej rośliny jest dobrana tak, by sygnalizować rzeczywistą wielkość danej rośliny (dla naprawdę dużych roślin pokazujemy dodatkowo dla porównania sylwetkę ogrodnika).",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(0)",
            title: "Dodawanie roślin do projektu",
            content: "Kliknij by wybrać daną roślinę. Potem dodaj ją do projektu, klikając na rysunek ogrodu w miejscu, w którym roślina ma zostać umieszczona (poniżej linii horyzontu).",
            action: function() {$(".GPPlantPickerItem:eq(0)").click();},
            allowed : () => {return true;}
        },
        {
            placement: function (context, source) {if ($(source).offset().left > 300) return "left"; else return "auto";},
            element: "#GPProjectView",
            title: "Korygowanie rozmieszczenia roślin",
            content: "Dodane rośliny można przesuwać tak, by uzyskać najlepszy efekt. Ich rozmiar będzie dostosowywany automatycznie, w zależności od ich gatunku, pozycji i ogólnej skali projektu. ",
            action: function() {if (!GP.project.items.length) {GP.project.addPlant(4066, 1160, 1160, 1); GPProjectView.initFromProject();}},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: "#itemInstanceDetails",
            title: "Dodatkowe opcje",
            content: "Kliknij w roślinę na projekcie aby otworzyć menu kontekstowe, które pozwala usunąć roślinę lub ręcznie poprawić jej rozmiar.",
            action: function() {mode.set("Plants"); selectedItemSet.set([GP.project.items[0]]);},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPModeTabs",
            title: "Akcesoria",
            content: "Przełącz zakładki, by dodać akcesoria i meble ogrodowe.",
            action: function() {mode.set("Structures");},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPTexturePickerItem:eq(0)",
            title: "Trawniki i inne nawierzchnie",
            content: "Aby dodać nawierzchnie (np. trawę, kostkę brukową, ścieżki), wybierz jedną z tekstur i 'namaluj' nawierzchnię na projekcie (pamiętaj, by rysować tylko w dolnej części projektu, poniżej linii horyzontu).",
            action: function() {mode.set("Textures");},
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPSnippetPickerItem:eq(0)",
            title: "Gotowe aranżacje",
            content: "Jeśli potrzebujesz inspiracji, możesz wybrać jedną z gotowych aranżacji. Możesz również stworzyć własną aranżację i zapisać ją jako szablon, by móc ją używać w przyszłości.",
            action: function() {mode.set("Snippets");},
            allowed: () => {return get(snippetsStore) && get(snippetsStore).length}
        },
        {
            placement: "auto",
            element: ".GPPlantPickerItem:eq(0)",
            title: "Szczegółowe informacje o roślinie",
            content: "Jeszcze słowo o wyszukiwarce roślin - kliknięcie w ikonkę <i class='fa fa-question-circle'></i> wyświetli szczegółowe informacje o roślinie",
            action: function() {mode.set("Plants");},
            allowed : () => {return true;}
        },
        {
            placement: "bottom",
            element: ".GPSeasonSwitch",
            title: "Zmiana pór roku",
            content: "Ta ikona zmieni wygląd projektu dostosowując go do wybranej pory roku.<br/><br/>Rośliny na projekcie zmienią automatycznie swój wygląd. Czasami może to spowodować zniknięcie kwiatów - nie martw się tym, tylko po prostu przełącz widok z powrotem na lato lub wiosnę!",
            allowed : () => {return true;}
        },
        {
            placement: "auto",
            element: ".GPMainNav",
            title: "Menu",
            content: "<span class='hidden-xs'>Tu są przyciski pozwalające uruchomić najczęstsze funkcje - wybrać Scenerię (obrazek w tle), ustawić parametry gleby i klimatu by odfiltrować nieodpowiednie rośliny, nagrać projekt itp. </span>Ikona <i class='fa fa-bars'></i> otworzy menu z&nbsp;dodatkowymi funkcjami.<br/><br/>Powodzenia!",
            template: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="modal" aria-labelledby="tutorial_popover_title" aria-modal="true">' +
                '<div class="arrow"></div>' +
                '<h3 id="tutorial_popover_title" class="popover-title"></h3>' +
                '<a class="gpTutorialClose" href="#" aria-label="Zamknij"><i class="fa fa-times" aria-hidden="true"></i></a>' +
                '<div class="popover-content"></div>' +
                '<div class="popover-footer">' +
                '<button type="button" class="btn btn-default gpTutorialPrev"><i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i> Wstecz</button>' +
                '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
                '<button type="button" class="btn btn-primary gpTutorialNext">Zamknij <i class="fa fa-times" aria-hidden="true"></i></button>' +
                '</div>' +
                '</div>',
            allowed : () => {return true;}
        },

    ],

    init: function () {
        GPTutorial.steps = GPTutorial['steps_'+GPSettings.language()];
        GPTutorial.popoverTemplate = GPTutorial['popoverTemplate_'+GPSettings.language()];

        if (localStorage['gptutorialdone'] !== "1") {
            $(document).on("GPAppStarted",function() {
                setTimeout(GPTutorial.delayedStart,500);
            });
        }
    },

    delayedStart: function() {
        GPTutorial.startTutorial();
    },

    currentStep : 0,

    startTutorial: function() {
        localStorage['gptutorialdone'] = "1";
        GPTutorial.steps = GPTutorial.steps.filter(s => s.allowed());
        GPTutorial.currentStep = 0;
        $('body').append(Mustache.render(GPTutorial.template,GPTutorial));

        GP.storeFocus();

        $(window).off('resize',GPTutorial.resize);
        $(window).on('resize',GPTutorial.resize);
        GPTutorial.showStep(0);
    },

    handleForwardClick: function() {
        GPTutorial.forwardTutorial();
    },

    handleBackwardClick: function() {
        GPTutorial.backTutorial();
    },

    forwardTutorial: function(n) {
        if (n===GPTutorial.currentStep) return;
        if (!arguments.length) n = GPTutorial.currentStep + 1;
        if (n < GPTutorial.steps.length) {
            GPTutorial.hideStep(GPTutorial.currentStep);
            GPTutorial.currentStep = n;
            GPTutorial.showStep(n);
        } else GPTutorial.closeTutorial();
    },

    backTutorial: function(n) {
        if (n<0) return;
        if (!arguments.length) n = GPTutorial.currentStep - 1;
        if (n >= 0) {
            GPTutorial.hideStep(GPTutorial.currentStep);
            GPTutorial.currentStep = n;
            GPTutorial.showStep(n);
        } else GPTutorial.closeTutorial();
    },

    showStep: function(n) {
        var data = GPTutorial.steps[n];

        function show() {
            var options = {
                content: data['content'],
                placement: data['placement'],
                template: (data['template'] || GPTutorial.popoverTemplate).replace("#n",n),
                title: n===0 ? data['title'] : '<i class="fa fa-graduation-cap"></i>' + data['title'],
                container: 'body',
                html: true,
                trigger: 'manual'
            };
            $(data['element']).on('shown.bs.popover',function (){$('.gpTutorialNext').focus()});
            $(data['element']).popover(options).popover('show');
            $('.gpTutorialPopover').addClass("gpTutorialStep"+n);

            GPTutorial.setOutline(data['element']);

            $('.gpTutorialStep').html(n);
            $('.gpTutorialTotalsteps').html(GPTutorial.steps.length-1);

            $('.gpTutorialNext').off().click(GPTutorial.handleForwardClick);
            $('.gpTutorialPrev').off().click(GPTutorial.handleBackwardClick);
            $('.gpTutorialClose, .gpTutorialCloseBtn').off().click(GPTutorial.closeTutorial);

            //trap focus
            $('.gpTutorialClose').off('keydown').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
            $('.gpTutorialNext').off('keydown').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

            $('.gpTutorialPopover').off('keydown').on("keydown", function(e) {if (e.which === 27) GPTutorial.closeTutorial()});
        }

        if (data['action']) {
            data['action']();
            setTimeout(show,500);
        } else show();

    },

    hideStep: function(n) {
        var data = GPTutorial.steps[n];
        $(data['element']).popover('destroy');
    },

    setOutline: function(el) {
        var t = $(el).offset().top,
            l = $(el).offset().left,
            w = $(el).outerWidth(),
            h = $(el).outerHeight();

        $('.gpTutorialOverlay').css("top",t).css("left",l).css("width",w).css("height",h);
    },

    closeTutorial: function() {
        for (var i=0; i < GPTutorial.steps.length; i++) {
            GPTutorial.hideStep(i);
        }
        $('.gpTutorial').remove();
        $(window).off('resize',GPTutorial.resize);

        $(document).off('click','.popover', GPTutorial.forwardTutorial);

        GP.restoreFocus();
    },

    resize: function() {
        var data = GPTutorial.steps[GPTutorial.currentStep];
        $(data['element']).popover('show');
        GPTutorial.setOutline(data['element']);
    },

    template: ' <div id="gpTutorial" class="gpTutorial" tabindex="-1">\
    <div class="gpTutorialOverlay"></div>\
    <div id="GPTutorialCenter"></div>\
    </div>',

    popoverTemplate: null,
    popoverTemplate_en: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="dialog" aria-modal="true" aria-labelledby="tutorial_popover_title">' +
    '<div class="arrow"></div>' +
    '<h3 id="tutorial_popover_title" class="popover-title"></h3>' +
    '<a class="gpTutorialClose" href="#" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></a>' +
    '<div class="popover-content"></div>' +
    '<div class="popover-footer">' +
    '<button type="button" class="btn btn-default gpTutorialPrev"><i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i> Previous</button>' +
    '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
    '<button type="button" class="btn btn-default gpTutorialNext">Next <i class="fa fa-long-arrow-alt-right" aria-hidden="true"></i></button>' +
    '</div>' +
    '</div>',

    popoverTemplate_pl: '<div class="popover gpTutorialPopover gpTutorialStep#n" role="dialog" aria-modal="true" aria-labelledby="tutorial_popover_title">' +
    '<div class="arrow"></div>' +
    '<h3 id="tutorial_popover_title"  class="popover-title"></h3>' +
    '<a class="gpTutorialClose" href="#" aria-label="Zamknij"><i class="fa fa-times" aria-hidden="true"></i></a>' +
    '<div class="popover-content"></div>' +
    '<div class="popover-footer">' +
    '<button type="button" class="btn btn-default gpTutorialPrev"><i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i> Wstecz</button>' +
    '<div class="gpTutorialCounter"><span class="gpTutorialStep"></span>/<span class="gpTutorialTotalsteps"></span></div>' +
    '<button type="button" class="btn btn-default gpTutorialNext">Dalej <i class="fa fa-long-arrow-alt-right" aria-hidden="true"></i></button>' +
    '</div>' +
    '</div>'

}

$(document).ready(GPTutorial.init);